<script lang="ts">
    import LanguagePickerListItems from "../../Languages/LanguagePickerListItems.svelte";
    import ItemsListInput from "../../ItemsList/ItemsListInput.svelte";

    import type { I18NMessage } from "@app/services/i18n.messages";
    import {
        SEARCH__translateFrom,
        SEARCH__translateInto,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { isMobile } from "@app/services/isMobile";
    import { debounce } from "@app/utils/debounce";
    import isPageRtl from "@app/components/IsPageRtl";

    export let languageType: string;
    export let onKeydown: (event: KeyboardEvent) => void;
    export let onInput: (event: Event) => void;
    export let onClose: () => void;

    let message: I18NMessage;
    $: {
        message =
            languageType === "source"
                ? SEARCH__translateFrom
                : SEARCH__translateInto;
    }

    function calculatePosition(isLeft: boolean): string {
        if (!isMobile()) {
            if (isLeft) {
                return "0";
            } else {
                return "-8rem";
            }
        } else {
            if (isLeft) {
                if (languageType === "source") {
                    return "0";
                } else {
                    return "auto";
                }
            } else {
                if (languageType === "source") {
                    return "auto";
                } else {
                    return "0";
                }
            }
        }
    }
    let container: HTMLDivElement;
    $: {
        if (container) {
            let width = Math.max(256, container.getBoundingClientRect().width);
            if (!isPageRtl()) {
                container.style.left = calculatePosition(true);
                container.style.right = calculatePosition(false);
            } else {
                container.style.right = calculatePosition(true);
                container.style.left = calculatePosition(false);
            }
            //if (isMobile()) {
            width = Math.min(window.innerWidth - 16, width);
            container.style.width = width + "px";
            //}
        }
    }
    function detectEscKeyPress(event: KeyboardEvent) {
        if (event.key === "Escape") {
            onClose();
        }
    }
</script>

<svelte:window on:keydown={detectEscKeyPress} />

<div
    class="languageListContainer"
    class:languageTypeTarget={languageType === "target"}
    bind:this={container}
>
    <div
        class="h-8 bg-primary-600 text-white w-full text-sm flex items-center rounded-t"
    >
        <div class="whitespace-nowrap text-xs p-2">
            {getMessage(message)}
        </div>
        <div class="flex-1 ">
            <ItemsListInput
                onInput={debounce(350, onInput)}
                {onKeydown}
                autoFocus={true}
                ariaLabel="Languages"
                classNames="text-gray-800 text-xs h-full block p-1 flex-1 my-2 w-full rounded"
            />
        </div>
        <button class="p-2" on:click={onClose}
            ><span class="icon-close" /></button
        >
    </div>
    <div
        class="bg-gray-50 shadow languagesList text-gray-900 border border-gray-300 border-t-0 overflow-y-scroll px-2 w-full text-sm text-left rounded-b"
    >
        <LanguagePickerListItems {languageType} />
    </div>
</div>

<style>
    .languageListContainer {
        position: absolute;
        top: 1.25rem;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 51;
    }
    .languagesList {
        overflow-y: auto;
        max-height: 60vh;
        padding-bottom: 1rem;
    }
    @media (min-height: 760px) {
        .languagesList {
            max-height: 40vh;
        }
    }
</style>
